'use strict';

function getUrlSlug(value) {
  return value
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
}

function getCategoryDataFromSlug({ I18n, categoryData, categorySlug }) {
  const category = categoryData.find(({ Id }) => {
    const name = I18n.t(`modules.category.Name.${Id}`);
    const slugifiedName = getUrlSlug(name);

    return slugifiedName === categorySlug;
  });

  return category || {};
}

function getSubCategoryIds({ parentId, categoryData }) {
  const subCategories = [];

  if (parentId) {
    categoryData.filter(category => {
      if (category.ParentId === parentId) {
        subCategories.push(category.Id);
      }
    });
  }

  return subCategories.length ? subCategories.join(',') : null;
}

function getUrl(url, params) {
  if (params && params.length) {
    return `${url}?${params.join('&')}`;
  }

  return url;
}

function getCategoryLink({ categoryName, routes }) {
  const categorySlug = getUrlSlug(categoryName);
  return {
    href: routes.category.show.replace('{categorySlug}', categorySlug),
    'data-bhc': `category:${categorySlug}`,
  };
}

function getCurrentThemedPageSlug(themes) {
  if (!themes) {
    return null;
  }

  const now = Date.now();
  const theme = themes.filter(event => {
    const startDate = event.startDate || event.StartDate;
    const endDate = event.endDate || event.EndDate;

    return new Date(startDate) < now && new Date(endDate) > now;
  });

  if (!Array.isArray(theme) || !theme.length) {
    return null;
  }

  const slug = theme[0].slug || theme[0].Slug;
  const title = theme[0].title || theme[0].Title;

  return { slug, title };
}

function getButtonUrl({ routes, merchantSlug, destination }) {
  if (merchantSlug && routes && routes.merchant && routes.merchant.show) {
    return routes.merchant.show.replace('{merchantSlug}', merchantSlug);
  }
  return destination;
}

function getRedirectUrl({ routes, offerData, offerId, utmMedium }) {
  if (offerData.offerType === 'OnlineCode') {
    const merchantRoute = routes.merchant.show.replace(
      '{merchantSlug}',
      offerData.merchant.merchantSlug
    );

    const params = [`did=${offerId}`];

    if (utmMedium) {
      params.push(`utm_medium=${utmMedium}`);
    }

    return getUrl(merchantRoute, params);
  }

  return routes.redirect.offers.replace('{offerId}', offerId);
}

function getReferralSource(ppcLandingPage, utmMedium) {
  if (ppcLandingPage) {
    return 'ppc';
  }

  if (utmMedium === 'email') {
    return 'email';
  }

  return '';
}

function isChromeExtensionSlug(slug) {
  if (slug && slug.toLowerCase() === 'coupons-for-merchant') {
    return true;
  }

  return false;
}

function isTermsAndConditions(slug) {
  if (slug && slug.toLowerCase() === 'advertiser-terms') {
    return true;
  }

  return false;
}

function isDealPage(currentURL) {
  return currentURL().searchParams.get('source') === 'deal-page';
}

function getURLWithUTMMedium(currentURL) {
  if (
    currentURL().searchParams.has('sid') &&
    currentURL().searchParams.has('utm_medium')
  ) {
    return currentURL().href.replace('sid', 'utm_campaign');
  }

  return '';
}

function getAffiliateURL({
  offerId,
  merchantId,
  referralSource,
  eventId,
  isMerchant,
}) {
  const { routes } = window.Groupon.Utils.getConfigFromDom();
  const params = [`currentUrl=${encodeURIComponent(window.location.href)}`];

  if (referralSource) {
    params.push(`referralSource=${referralSource}`);
  }

  if (eventId) {
    params.push(`eventId=${eventId}`);
  }

  const path = isMerchant
    ? routes.redirect.merchant.replace('{merchantId}', merchantId)
    : routes.redirect.offers.replace('{offerId}', offerId);

  const url = getUrl(path, params);

  return new URL(`${window.location.origin}${url}`);
}

module.exports = {
  getUrlSlug,
  getCategoryDataFromSlug,
  getSubCategoryIds,
  getUrl,
  getCategoryLink,
  getCurrentThemedPageSlug,
  getButtonUrl,
  getRedirectUrl,
  getReferralSource,
  isChromeExtensionSlug,
  isTermsAndConditions,
  isDealPage,
  getURLWithUTMMedium,
  getAffiliateURL,
};
